import Carousel from '@/components/carousel'
import DownloadApps from '@/components/downloadApps'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import {
  appList,
  ASSET_DIR,
  brandList,
  imageList,
  STRINGS,
} from '@/constants/agriInput'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const AgriInput = () => (
  <LayoutWithNavigation>
    <section className="px-6 my-4 max-w-7xl m-auto">
      <PageHeader
        heading={STRINGS.AGRI_INPUT}
        subHeading={STRINGS.SEED_FERTILIZERS_PESTICIDES}
      />
      <section className="flex md:flex-row flex-col">
        <div className="md:flex-1 pt-4">
          <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base font-natosans-light">
            {STRINGS.DESCRIPTION}
          </p>
          <div className="py-2.5">
            <DownloadApps apps={appList} />
          </div>
        </div>
        <div className="md:w-1/3 md:px-4 py-2.5">
          <Picture
            image={`${ASSET_DIR}/input`}
            imageAlt="Seedling concept by human hand apply fertilizer young tree over green background"
            loading="eager"
            imageStyle="w-full"
          />
        </div>
      </section>

      <section className="pt-8">
        <Carousel
          imageList={imageList}
          aspectRatio={524 / 466}
          desktopImageCount={4}
          mobileImageCount={1}
        />
      </section>
      <section className="pt-8">
        <Carousel
          imageList={brandList}
          aspectRatio={377 / 233}
          desktopImageCount={6}
          mobileImageCount={1}
        />
      </section>
      <section>
        <h2 className="md:text-3xl text-xl md:font-natosans-medium font-natosans mt-5 mb-[30px]">
          {STRINGS.BLESSING}
        </h2>
        <section className="flex md:flex-row flex-col">
          <article className="md:pr-4 md:w-2/3 w-full">
            <div className="mt-2.5 overflow-hidden">
              <Picture
                image={`${ASSET_DIR}/gautam-singh`}
                imageAlt={STRINGS.GAUTAM_SINGH}
                imageStyle="aspect-square md:w-[9%] w-[100px] rounded-full"
              />
            </div>
            <p className="mb-2.5 text-[#333333] text-base">
              -{STRINGS.GAUTAM_SINGH}
            </p>
            <p className="mb-2.5 text-[#333333] text-base">
              {STRINGS.ABOUT_GAUTAM_SINGH}
            </p>
          </article>
          <div className="md:pl-4 md:w-1/3 w-full">
            <iframe
              src="https://www.youtube.com/embed/7kyuNpYFaSk"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              className="w-full h-full"
              loading="lazy"
            />
          </div>
        </section>
      </section>
    </section>
  </LayoutWithNavigation>
)

export default AgriInput
